import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">黄瓜视频</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed mb-5">
              黄瓜视频是一款备受欢迎的短视频平台，提供海量高清视频内容，覆盖娱乐、生活、美食、科技等丰富类目，让你随时随地享受优质视频体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-background-50"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-sm mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-sm mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-sm mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">
                  平台荣誉
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2024-2026 黄瓜视频 huangguavideo.com 版权所有 | ICP备2024000000号
          </p>
          <p className="text-xs text-background-50/40">
            黄瓜视频 - 高清短视频平台 | 免费在线观看与下载
          </p>
        </div>
      </div>
    </footer>
  );
}